module.exports = __webpack_public_path__ + "static/media/trending.1606468e.png";